import { Pagination, useTheme } from '@mui/material';
import React from 'react';

const PaginationBasic = ({
    paddingt,
    callBack,
    total = 1,
    currentPage = 1,
    disabled = false
}: {
    paddingt?: number;
    callBack?: (pageNew: number) => void;
    total?: number;
    currentPage?: number;
    disabled?: boolean;
}) => {
    const theme = useTheme();
    const [page, setPage] = React.useState(currentPage + 1);
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        callBack?.(value - 1);
    };

    return (
        <Pagination
            count={total}
            page={page}
            defaultPage={page}
            onChange={handleChange}
            disabled={disabled}
            sx={{
                display: 'flex',
                justifyContent: 'end',
                pt: paddingt,
                '.MuiPaginationItem-root.Mui-selected': {
                    backgroundColor: theme.palette.primary.main,
                    color: 'white'
                },
                '.MuiPaginationItem-root.Mui-selected:hover': {
                    backgroundColor: theme.palette.primary.light
                },
                '.MuiPaginationItem-root.Mui-disabled': {
                    opacity: 1
                    // color: theme.palette.success.main
                }
            }}
        />
    );
};

export default PaginationBasic;
